<template>
  <div>
    <div class="add-box common-shadow">
      <vxe-table
          border="none"
          show-overflow
          :auto-resize="true"
          align="center"
          :data="tableData"
      >
        <vxe-table-column field="carShipNum" title="车船号" width="14%">
          <template slot-scope="{ row }">
            <div v-if="isHavePermission('logistics2.0:carShipDetail')">
              <a v-if="row.logisticsType === 1" @click="showCarDetail(row)">{{
                  row.carShipNum
                }}</a>
              <a v-if="row.logisticsType === 2" @click="showShipDetail(row)">{{
                  row.carShipNum
                }}</a>
            </div>
            <div v-else>
              <span>{{ row.carShipNum }}</span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="beginPlace" title="起运地" width="14%">
        </vxe-table-column>
        <vxe-table-column field="beginTime" title="起运时间" width="14%">
          <template v-slot="{ row }">
            <span>{{ row.beginTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endPlace" title="到达地" width="14%">
        </vxe-table-column>
        <vxe-table-column field="endTime" title="到达时间" width="14%">
          <template v-slot="{ row }">
            <span>{{ row.endTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="driverName" title="实际承运人" width="14%" v-if="isHavePermission('ordersTwo:showDriverName')">
          <template slot-scope="{ row }">
            <a @click="openUserInfo(row)">{{ row.driverName }}</a>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column
            field="contact"
            title="联系方式"
            width="12.5%"
        ></vxe-table-column> -->
        <vxe-table-column field="logisticsFiles" title="附件" width="16%">
          <template v-slot="{ row }">
            <upload-detail :arrList="row.logisticsFiles"></upload-detail>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <vxe-modal
        v-model="createCarVisible"
        :title="createCarTitle"
        width="1400"
        height="860"
        @close="closeCarCreate"
        resize
        position="center"
    >
      <create-car-modal
          @afterSave="closeCarCreateModal"
          ref="modalCarCreate"
          @close="closeCar"
      ></create-car-modal>
    </vxe-modal>
    <vxe-modal
        v-model="createShipVisible"
        :title="createShipTitle"
        width="1400"
        height="900"
        @close="closeShipCreate"
        resize
        position="center"
        destroy-on-close
    >
      <create-ship-modal
          @afterSave="closeShipCreateModal"
          @close="createShipVisible = false"
          ref="modalShipCreate"
      ></create-ship-modal>
    </vxe-modal>
    <vxe-modal
        v-model="userInfoModal"
        width="1400"
        height="800"
        position="center"
        title="查看用户信息"
        destroy-on-close
    >
      <user-center
          :userId="editUserId"
          :userType="userType"
          :isUserEdit="false"
          :userName="userName"
          ref="userCenter"
      ></user-center>
    </vxe-modal>
    <vxe-modal v-model="driverModal" width="1450" height="800" position="center" title="查看用户信息" destroy-on-close>
      <user-center-driver :userId="editUserId" ref="userCenter"></user-center-driver>
    </vxe-modal>
  </div>
</template>

<script>
import UploadDetail from "@/components/common/UploadDetail";
import CreateCarModal from "@/views/carShip/CreateCarModal";
import CreateShipModal from "@/views/carShip/CreateShipModal";
import UserCenter from "@/views/account/UserCenter";
import UserCenterDriver from "@/components/userManage/UserCenter";

import {apiGet, apiPost} from "@/utils/api";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  props: {
    detailData: Object
  },
  components: {
    UploadDetail,
    CreateCarModal,
    CreateShipModal,
    UserCenter,
    UserCenterDriver
  },
  mixins: [getAuthOrization],
  watch: {
    detailData(val) {
      if (val) {
        this.tableData = [
          {
            carShipNum: val.carShipNum,
            beginPlace: val.beginPlace,
            beginTime: val.beginTime,
            endPlace: val.endPlace,
            endTime: val.endTime,
            driverName: val.driverName,
            contact: val.contact,
            logisticsFiles: val.logisticsFiles,
            logisticsType: val.logisticsType,
            carShipId: val.carShipId,
            driverId: val.driverId,
          }
        ];
      }
    }
  },
  data() {
    return {
      tableData: [
        {
          carShipNum: null,
          beginPlace: null,
          beginTime: null,
          endPlace: null,
          endTime: null,
          driverName: null,
          contact: null,
          logisticsFiles: null
        }
      ],
      createCarVisible: false,
      createShipVisible: false,
      createCarTitle: "",
      createShipTitle: "",
      userInfoModal: false,
      editUserId: null,
      userType: null,
      userName: null,
      driverModal: false
    };
  },
  methods: {
    async openUserInfo(row) {
      let id = row.driverId;
      let url = this.detailData.logisticsType === 1 ? 'baseUserSign/queryUserInfoClientDetail' : "baseUserSign/getUserSignById";
      let params = this.detailData.logisticsType === 1 ? {id: id} : {userId: id}
      let res;
      if (this.detailData.logisticsType === 1) {
        res = await apiPost("api/auth/", url, params);
      } else {
        res = await apiGet("api/auth/", url, params);
      }

      if (res.status === 1) {
        this.editUserId = id;
        if (this.detailData.logisticsType === 1) {
          this.driverModal = true;
        } else {
          this.userName = row.driverName;
          this.userType = res.data.userType;
          this.userInfoModal = true;
        }
      } else {
        this.$Modal.error({
          title: "错误提示",
          content: res.message
        });
      }
    },
    showCarDetail(row) {
      if (row.carShipId) {
        this.createCarTitle = "查看车辆信息";
        this.createCarVisible = true;
        this.$refs.modalCarCreate.init();
        this.$refs.modalCarCreate.queryCarDetail(row.carShipId);
        this.$refs.modalCarCreate.setReadOnly();
      } else {
        this.$XModal.alert({
          message: "暂无车辆信息",
          status: "error"
        });
      }
    },
    showShipDetail(row) {
      if (row.carShipId) {
        this.createShipTitle = "查看船舶信息";
        this.createShipVisible = true;
        this.$nextTick(() => {
          this.$refs.modalShipCreate.queryShipDetailNew(row.carShipId);
          this.$refs.modalShipCreate.setReadOnly();
        });
      } else {
        this.$XModal.alert({
          message: "暂无船舶信息",
          status: "error"
        });
      }
    },
    closeCarCreateModal(type) {
      this.createCarVisible = false;
    },
    closeCarCreate() {
      this.$refs.modalCarCreate.reset();
    },
    closeCar() {
      this.createCarVisible = false;
      this.$refs.modalCarCreate.clearV();
    },
    closeShipCreateModal() {
      this.createShipVisible = false;
      // this.queryLogisticsList();
    },
    closeShipCreate() {
      this.$refs.modalShipCreate.reset();
    }
  }
};
</script>

<style>
</style>